import type { ReactElement } from 'react';
import { Link } from 'react-router';

/**
 * 교육 문의 카드.
 *
 * 자료실과 영상 상세 양쪽에서 같은 자리를 맡는다.
 *
 * **본문 아래가 아니라 옆에 둔다.** 아래에 두면 끝까지 스크롤한 사람만 보고,
 * 자료실은 원래 목록만 훑고 나가는 화면이라 끝까지 내려가지 않는다.
 *
 * 자료를 받으러 온 사람에게 파는 자리가 아니다 — 있다는 것만 알리고 비켜선다.
 * 그래서 면을 깔지 않고 흰 카드로 둔다.
 */
export function EducationInquiryCard({ className = '' }: { className?: string }): ReactElement {
  return (
    <aside
      aria-labelledby="education-inquiry-card-heading"
      className={`flex flex-col gap-3 rounded-lg border border-border bg-card p-5 ${className}`}
    >
      <h2
        id="education-inquiry-card-heading"
        className="text-[14.5px] font-semibold tracking-[-0.02em]"
      >
        자동화 컨설팅 및 교육
      </h2>

      <p className="text-[13px] leading-[1.75] text-muted-foreground">
        진단부터 실습, 정착까지 설계합니다.
      </p>

      <Link
        to="/education"
        className="inline-flex h-10 items-center justify-center rounded-md border border-foreground px-4 text-[13.5px] font-medium transition-colors hover:bg-foreground hover:text-background"
      >
        문의하기
      </Link>
    </aside>
  );
}
